/** Mandanten-Slug für Schulungs-/Test-Hosts (test.*). */
export const TRAINING_TENANT_SLUG = "test";

const TEST_HOST_PREFIXES = [
  "test.app.",
  "test.booking.",
  "test.shop.",
  "test.www.",
  "test.neu.",
] as const;

export function isTestAppHost(hostname: string): boolean {
  return hostname.startsWith("test.app.");
}

export function isTestBookingHost(hostname: string): boolean {
  return hostname.startsWith("test.booking.");
}

export function isTestShopHost(hostname: string): boolean {
  return hostname.startsWith("test.shop.");
}

export function isTestWebsiteHost(hostname: string): boolean {
  return hostname.startsWith("test.www.") || hostname.startsWith("test.neu.");
}

export function isTrainingHost(hostname: string): boolean {
  return TEST_HOST_PREFIXES.some((prefix) => hostname.startsWith(prefix));
}

/** Liefert den Schulungs-Mandanten-Slug, wenn der Host ein Test-Host ist. */
export function tenantSlugFromHostname(hostname: string): string | null {
  if (isTrainingHost(hostname)) return TRAINING_TENANT_SLUG;
  return null;
}

export function resolveTenantSlug(options: {
  hostname?: string;
  fromMeta?: string | null;
  fromEnv?: string | null;
}): string {
  const hostname =
    options.hostname ??
    (typeof window !== "undefined" ? window.location.hostname : "");
  const fromHost = tenantSlugFromHostname(hostname);
  if (fromHost) return fromHost;

  const fromMeta = options.fromMeta?.trim();
  if (fromMeta) return fromMeta.toLowerCase();

  const fromEnv = options.fromEnv?.trim();
  if (fromEnv) return fromEnv.toLowerCase();

  return "default";
}
